import React from 'react';
import ReactDOM from 'react-dom';

/**
 * Component for createPortal method from react
 * @param id
 * @param children
 * @returns {React.ReactPortal|null}
 * @constructor
 */
const ReactPortal = ({ id, children }) => {
    const [hasMounted, setHasMounted] = React.useState(false);
    React.useEffect(() => {
        setHasMounted(true);
    }, []);
    if (!hasMounted) {
        return null;
    }
    return ReactDOM.createPortal(
        children,
        document.querySelector(`#${id}`)
    );
}

export default ReactPortal